var map = {
	"./reference-br.png": 1723,
	"./reference-cs.png": 1724,
	"./reference-de.png": 1725,
	"./reference-en.png": 1726,
	"./reference-es.png": 1727,
	"./reference-fi.png": 1728,
	"./reference-fr.png": 1729,
	"./reference-hu.png": 1730,
	"./reference-it.png": 1731,
	"./reference-nl.png": 1732,
	"./reference-no.png": 1733,
	"./reference-pl.png": 1734,
	"./reference-ro.png": 1735,
	"./reference-ru.png": 1736,
	"./reference-sk.png": 1737,
	"./reference-sv.png": 1738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1722;